import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom'

import NotFoundView from './views/NotFound'
import LoadingScreen from './components/common/LoadingScreen';

const Home = lazy(() => import('./Home'));
const Login = lazy(() => import('./views/Login'))
const ForgotPassword = lazy(() => import('./views/ForgotPassword'))
const ResetPassword = lazy(() => import('./views/ResetPassword'))
const Health = lazy(() => import('./views/Health'))
const GrabacionQrMovil = lazy(() => import('./views/GrabacionQrMovil'))
const PatientVideoJoin = lazy(() => import('./views/PatientVideoJoin'))
const MiCita = lazy(() => import('./views/MiCita'))
const Privacidad = lazy(() => import('./views/Privacidad'))

function AppRoutes() {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/health" element={<Health />} />
                <Route path="/grabacion/:token" element={<GrabacionQrMovil />} />
                <Route path="/enlace-video/:token" element={<PatientVideoJoin />} />
                {/* [M-4] Forma nueva: el token va en el fragmento (/mi-cita#<token>),
                    que no llega al servidor ni queda en sus registros. La forma con
                    el token en la ruta se mantiene por los enlaces ya enviados. */}
                {/* [NGT 237 IX.B.3.c] El aviso de privacidad se publica sin
                    sesion: lo tiene que poder leer el paciente que entra por el
                    enlace de su cita, que no tiene cuenta, y cualquiera antes de
                    entrar al sistema. */}
                <Route path="/privacidad" element={<Privacidad />} />
                <Route path="/mi-cita" element={<MiCita />} />
                <Route path="/mi-cita/:token" element={<MiCita />} />
                <Route path='/admin/*' element={<Home />} />
                <Route path="*" element={<NotFoundView />} />
            </Routes>
        </Suspense>
    )
}
export default AppRoutes;
